var map = {
	"./": "../../node_modules/@paypalcorp/instance-location/geo/index.js",
	"./common": "../../node_modules/@paypalcorp/instance-location/geo/common.js",
	"./common.js": "../../node_modules/@paypalcorp/instance-location/geo/common.js",
	"./index": "../../node_modules/@paypalcorp/instance-location/geo/index.js",
	"./index.js": "../../node_modules/@paypalcorp/instance-location/geo/index.js",
	"./msgeo": "../../node_modules/@paypalcorp/instance-location/geo/msgeo.js",
	"./msgeo.js": "../../node_modules/@paypalcorp/instance-location/geo/msgeo.js",
	"./pp_cn": "../../node_modules/@paypalcorp/instance-location/geo/pp_cn.js",
	"./pp_cn.js": "../../node_modules/@paypalcorp/instance-location/geo/pp_cn.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../node_modules/@paypalcorp/instance-location/geo sync recursive ^\\.\\/.*$";